export default "__VITE_ASSET__DW9l0JFA__"